<template>
    <main :class="classObject">
        <slot></slot>
    </main>
</template>

<script>
export default {
    computed: {
        classObject: function() {
            return {
                main: true,
                "sidebar-open": !this.$root.sidebarHidden
            };
        }
    }
};
</script>
